import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import PtButton from '@com/pt-components/pt-button/index.vue';
import { PtButtonTheme as _PtButtonTheme, PtButtonType as _PtButtonType } from '@com/pt-components/pt-button/enum';
export default {
  components: {
    PtButton: PtButton
  },
  computed: {
    PtButtonTheme: function PtButtonTheme() {
      return _PtButtonTheme;
    },
    PtButtonType: function PtButtonType() {
      return _PtButtonType;
    }
  },

  methods: {
    resetTemplate: function resetTemplate() {
      var _this = this;

      this.$confirm('<p class="reset-template-title">' + this.$t('playTurbo.commonTemplate.resetTemplate.warnTitle') + '</p><p class="reset-template-detail">' + this.$t('playTurbo.commonTemplate.resetTemplate.warnDetail') + '</p>', '', {
        confirmButtonText: this.$t('common.confirmButtonText'),
        cancelButtonText: this.$t('common.cancelButtonText'),
        dangerouslyUseHTMLString: true,
        customClass: 'reset-template-dialog',
        type: 'warning',
        showClose: false
      }).then(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var loading;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading = _this.$loading({
                  lock: true,
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });
                _context.prev = 1;
                _context.next = 4;
                return _this.$store.dispatch('creative/template/resetTemplate', {
                  isResetAll: 1
                });

              case 4:
                loading.close();
                window.location.reload();
                _context.next = 13;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                console.error(_context.t0);
                _this.$message.error('Reset failed');
                loading.close();

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8]]);
      }))).catch(function () {});
    }
  }
};